import firebase from 'firebase/compat/app'
import 'firebase/compat/analytics'

const firebaseConfig = {
  apiKey: 'AIzaSyDHBWakuZvVhUvwaUubur4UnGRK-OC-wmo',
  authDomain: 'muttertag-3db61.firebaseapp.com',
  databaseURL: 'https://muttertag-3db61.firebaseio.com',
  projectId: 'muttertag-3db61',
  storageBucket: 'muttertag-3db61.appspot.com',
  messagingSenderId: '998086074216',
  appId: '1:998086074216:web:620903858615714487c0dd',
  measurementId: 'G-54Y82VCWZC'
}

export const firebaseApp = !firebase.apps.length ? firebase.initializeApp(firebaseConfig, 'default') : firebase.app('default')

export function enableAnalytics() {
  firebaseApp.analytics().setAnalyticsCollectionEnabled(true)
}

export function disableAnalytics() {
  firebaseApp.analytics().setAnalyticsCollectionEnabled(false)
}
